export default "__VITE_ASSET__66ec50b3__"